import {AbstractFilter} from '@gongxigames/framework/slot';
import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Session} from 'com/gongxigames/math/core/game/session/Session';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {Bonus} from 'com/gongxigames/math/core/game/engine/bonus/Bonus';
import {WolfHavenPickBonus} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenPickBonus';

export class ChosenFgTypeFilter extends AbstractFilter {
    protected _fgType: number;

    constructor(name: string, fgType: number) {
        super(name);
        this._fgType = fgType;
    }

    public filter(response: Message, session: Session): boolean {
        if (response.getAction() === Action.SPIN) {
            const bonus = session.getBonus<WolfHavenPickBonus>(Bonus.PICK_BONUS);

            return bonus != null && !bonus.isFinished() && bonus.getFreeGameType() === this._fgType ||
                (bonus && bonus.getPickedValues().length === 10);
        } else {
            return true;
        }
    }
}
